import { TourConfig, TourName } from '../types/Tour'
import { importTourSteps } from './importTourSteps'
import { layoutTourSteps } from './layoutTourSteps'
import { planningTourSteps } from './planningTourSteps'
import { runsheetTourSteps } from './runsheetTourSteps'

export const TOUR_STORAGE_KEYS = {
  LAYOUT: 'layout-tour-completed',
  PLANNING: 'planning-tour-completed',
  RUNSHEET: 'runsheet-tour-completed',
  IMPORT: 'import-tour-completed',
} as const

export const TOUR_CONFIGS: Record<TourName, TourConfig> = {
  layout: {
    steps: layoutTourSteps,
    storageKey: TOUR_STORAGE_KEYS.LAYOUT,
    readinessCheck: {
      elementSelector: layoutTourSteps.map(step => step.element).filter(ele => ele !== undefined) as string[],
      maxAttempts: 20,
      intervalMs: 300,
    },
  },
  planning: {
    steps: planningTourSteps,
    dependencies: [{
      tourName: 'layout',
      storageKey: TOUR_STORAGE_KEYS.LAYOUT,
    }],
    storageKey: TOUR_STORAGE_KEYS.PLANNING,
    readinessCheck: {
      elementSelector: layoutTourSteps.map(step => step.element).filter(ele => ele !== undefined) as string[],
      maxAttempts: 80,
      intervalMs: 200,
    },
  },
  runsheet: {
    steps: runsheetTourSteps,
    dependencies: [{
      tourName: 'layout',
      storageKey: TOUR_STORAGE_KEYS.LAYOUT,
    }],
    storageKey: TOUR_STORAGE_KEYS.RUNSHEET,
  },
  import: {
    steps: importTourSteps,
    dependencies: [{
      tourName: 'layout',
      storageKey: TOUR_STORAGE_KEYS.LAYOUT,
    }],
    readinessCheck: {
      elementSelector: layoutTourSteps.map(step => step.element).filter(ele => ele !== undefined) as string[],
      maxAttempts: 20,
      intervalMs: 50,
    },
    storageKey: TOUR_STORAGE_KEYS.IMPORT,
  },
}